<template>
  <a-modal
      title="选择职称名称"
      :visible="visible"
      @ok="handleOk"
      :maskClosable="false"
      @cancel="handleCancel"
      :confirm-loading="confirmLoading"
      :width="1300">
    <div class="mb-2">
      已选择职称：
      <template v-for="(item) in professionalTitleList">
        <template v-for="(item2) in item.items">
          <a-button-group v-if="item2.selected" size="small" class="ml-2 mb-2">
            <a-button>{{ item.name }}/{{ item2.name }}</a-button>
            <a-button @click="removeMethod(item2)" type="danger">
              <a-icon type="delete"></a-icon>
            </a-button>
          </a-button-group>
        </template>
      </template>
    </div>
    <a-row type="flex" :gutter="12">
      <a-col :span="6">
        <div class="zdy_ul_box">
          <ul class="zdy_ul">
            <li :class="item.active?'active':''" v-for="item in professionalTitleList">
              <span @click="onSelectChange(item)">{{ item.name }}</span>
              <a-icon type="right"/>
            </li>
          </ul>
        </div>
      </a-col>
      <a-col :span="18">
        <div class="zdy_ul_box">
          <ul class="zdy_ul" style="text-align: center;padding-top: 20%;">
            <a-checkbox v-for="item2 in professionalTitleItemList.items" v-model="item2.selected">{{ item2.name }}
            </a-checkbox>
          </ul>
        </div>
      </a-col>
    </a-row>
  </a-modal>

</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import { GetProfessionalTitleList } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'

export default {
  name: 'ChooseExtractProfessionalTitle',
  components: {
    PageView,
    STable
  },
  mounted () {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      confirmLoading: false,
      professionalTitleList: [],//职称列表
      professionalTitleItemList: {},//具体职称列表
      id: undefined,
    }
  },
  created () {
  },
  watch: {
    visible (val) {
      if (val) {
        this.professionalTitleItemList = {}
      }
    }
  },
  methods: {
    //数据回显
    async preView (json, id) {
      this.id = id
      console.log(json)
      await this.getProfessionalTitleList(json)
    },
    //确认后数据传回调用方
    handleOk () {
      let userSelectContent = []
      this.professionalTitleList.forEach(item => {
        item.items && item.items.forEach(item2 => {
          if (item2 && item2.selected) {
            userSelectContent.push({
              name: item.name + '/' + item2.name,
              value: item.value + '/' + item2.value
            })
          }
        })
      })
      this.$emit('success', userSelectContent, this.id)
    },
    //关闭窗口
    handleCancel () {
      this.$emit('cancel')
    },
    //获取职称数据
    async getProfessionalTitleList (json) {
      try {
        let res = await GetProfessionalTitleList()
        if (200 === res.code) {
          res.result && res.result.forEach(item => {
            item.active = false
            item.items.forEach(item2 => {
              item2.selected = false
            })
          })
          this.professionalTitleList = [...res.result]
          if (json && json.length > 0) {
            json.forEach(item => {
              let data = this.professionalTitleList.filter(item2 => item.value.includes(item2.value))[0]
              if (data) {
                let data2 = data.items.filter(item3 => item.value.includes(item3.value))[0]
                if (data2) {
                  data2.selected = true
                }
              }
            })
          }
        }
      } catch (e) {
        this.$message.error(e.message)
      } finally {
      }
    },

    //处理文字选中状态
    async onSelectChange (item) {
      this.professionalTitleList.map(item2 => {
        item2.active = item2.id === item.id
      })
      //获取选中的数据
      this.professionalTitleItemList = { ...item }
    },
    removeMethod (data) {
      data.selected = false
    },
  }
}
</script>

<style lang="less" scoped>
.card {
  margin-bottom: 24px;
}

/deep/ .ant-empty {
  margin: 90px 8px;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}

.close-span:hover {
  cursor: pointer;
}
</style>
